import moment from 'moment-timezone'
import { TIME_ZONE } from 'const/common'

// 根据 expiry 获取时间戳
/**
 * 根据 expiry 获取时间戳
 * 此处假设传入字符只存在 20181001 1538323200000 1538323200 三种形式
 * @param {string | number} expiry
 * @return {number}
 */
export default function getOptionExpiryStamp(expiry) {
  const len = String(expiry).length
  // 8位或者14位数表示为 YYYYMMDDHHMMSS
  if (len === 8 || len === 14) { return moment.tz(String(expiry), TIME_ZONE.US).valueOf() }
  // 10 位数表示为秒级时间戳
  if (len === 10) return expiry * 1000
  return Number(expiry)
}
